export default "__VITE_ASSET__BZu3EJEB__"